import React from 'react';
import PropTypes from 'prop-types';
import './CustomLegend.scss';

function CustomLegend({ payload }) {
  return (
    <div className="custom-legend">
      {payload?.map((entry) => (
        <div key={`item-${entry}`} className="legend-item">
          <div className="legend-color-box" style={{ backgroundColor: entry.color }} />
          <span className="legend-label">{entry.value}</span>
        </div>
      ))}
    </div>
  );
}

CustomLegend.propTypes = {
  payload: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      value: PropTypes.string
    })
  )
};

CustomLegend.defaultProps = {
  payload: []
};

export default CustomLegend;
